<script>
import { Pie, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
   name: 'ddoGraphPie',
   extends: Pie,
   mixins: [reactiveProp],
   props: {
      chartData: {
         type: Object,
         default: null
      },
      options: {
         type: Object,
         default: null
      },
   },
   data: function () {
      return {
      }
   },

   mounted() {
      this.renderChart(this.chartData, this.options);
   },

   methods: {

      update() {
         this.renderChart(this.chartData, this.options);
      },
   }

}
</script>